import React, {useEffect, useState} from 'react';
import "./StyleNewPasswordPopUp.css"
import CustomSearch3 from "../../../components/CustomSearch2/CustomSearch3";
import {
    UPDATE_SELECTED_SHOP_ID,
    REQUEST,
    GET_SELECTED_SHOP_NAME, GET_SELECTED_SHOP_ID, UPDATE_SELECTED_SHOP_NAME,
} from "../../../utils/js/Const";
import {FetchElements} from "../../../utils/js/request";
import {useNavigate} from "react-router-dom";
import CustomAlert from "../../../components/CustomAlert/CustomAlert";

const NewPasswordPopUp = ({ isOpenPopUp, onClosePopUp }) => {

    let navigate = useNavigate();

    const [shops, setShops] = useState([]);
    const [shopIdSelect, setShopIdSelect] = useState(GET_SELECTED_SHOP_ID());
    const [shopNameSelect, setShopNameSelect] = useState(GET_SELECTED_SHOP_NAME() || "");

    const [isOpenAlert, setIsOpenAlert] = useState(false);
    const [alertMessage, setAlertMessage] = useState('');
    const [alertStatusCod, setAlertStatusCod] = useState('')
    const [alertTitle, setAlertTitle] = useState('');

    useEffect(() => {
        FetchElements(
            `${REQUEST}/api/v1/shops/remind`,
            "GET",
            (data) => {
                setShops(data);
            },
            () => {
                navigate("/");
            }
        );
    },[])

    const handel_Select_ID_CUST = (data)=>{
        UPDATE_SELECTED_SHOP_ID(data)
        setShopIdSelect(data)
    }

    const handel_Select_NAME_CUST = (data)=>{
        UPDATE_SELECTED_SHOP_NAME(data)
        setShopNameSelect(data)
    }

    function getNewPassword(){
        fetch(`${REQUEST}/api/v1/users/remind?shop_id=${shopIdSelect}`, {
            method: 'GET',
        })
            .then(response => response.json())
            .then(result => {
                if (result.result) {
                    handleOpenAlert("Уведомление", result.message);
                } else {
                    handleOpenAlert("Ошибка", result.message);
                }
            })
            .catch(error => {
                handleOpenAlert("Ошибка", error.message);
            });
    }

    const handleOpenAlert = (title, message, statusCod) => {
        setAlertTitle(title);
        setAlertMessage(message);
        setAlertStatusCod(statusCod);
        setIsOpenAlert(true);
    };

    const handleCloseAlert = () => {
        setIsOpenAlert(false);
    };

    if (!isOpenPopUp) return null;

    return (
        <>
            <div className={`new_password_wrapper ${isOpenPopUp ? 'open' : ''}`}>
                <CustomAlert
                    title={alertTitle}
                    message={alertMessage}
                    isOpenAlert={isOpenAlert}
                    statusCod={alertStatusCod}
                    onClose={handleCloseAlert}
                />
                <div className={"new_password_wrapper-close_btn"} onClick={onClosePopUp}>+</div>
                <div className={"new_password_wrapper-form"}>
                    <CustomSearch3 name={"Магазин"}
                                   data={shops}
                                   idSelectedItem={handel_Select_ID_CUST}
                                   dropdown_wrapper_modifikator={"popUpSerach"}
                                   dropdown_header_modifikator={`headerMode`}
                                   selected={handel_Select_NAME_CUST}
                                   initialValue={shopNameSelect}
                                   dropdown_content_modifClass={'dropdown_content_modify'}
                    />
                    <button className="default_button new_password_wrapper-submit_btn" type="button" onClick={getNewPassword}>
                        Отправить
                    </button>
                </div>
            </div>
        </>
    );
};

export default NewPasswordPopUp;